export function getCachedOrCreate(map, store, key, create) {
  if (!map[store]) map[store] = {};
  if (!map[store][key]) map[store][key] = create();
  return map[store][key];
}